import { render, staticRenderFns } from "./Calendarios.vue?vue&type=template&id=74f2129a&"
import script from "./Calendarios.vue?vue&type=script&lang=ts&"
export * from "./Calendarios.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('74f2129a', component.options)
    } else {
      api.reload('74f2129a', component.options)
    }
    module.hot.accept("./Calendarios.vue?vue&type=template&id=74f2129a&", function () {
      api.rerender('74f2129a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Calendarios/Calendarios.vue"
export default component.exports